import { render, staticRenderFns } from "./DeleteItemAction.vue?vue&type=template&id=4a50a818&"
import script from "./DeleteItemAction.vue?vue&type=script&lang=js&"
export * from "./DeleteItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports